define('home/templates/homepageCommentsModuleEmptyView',['handlebars', 'handlebars.partials', 'core/extensions/handlebars.helpers'], function(Handlebars) {

return Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    return "";
},"3":function(container,depth0,helpers,partials,data) {
    return "<p><a href=\"/home/explore/people/\">"
    + container.escapeExpression(helpers.gettext.call(depth0 != null ? depth0 : {},"Find interesting users to follow",{"name":"gettext","hash":{},"data":data}))
    + "</a></p>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : {};

  return "<div class=\"post-comments__wrapper\">\n<div class=\"empty-message post-comments\">\n<span class=\"icon-empty-comment text-gray-light icon-huge\"></span>\n<p>"
    + container.escapeExpression(helpers.gettext.call(alias1,"Follow other %(disqus)s users to see their latest comments appear here.",{"name":"gettext","hash":{"disqus":"Disqus"},"data":data}))
    + "</p>\n"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.onboardingWithoutChannels : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"data":data})) != null ? stack1 : "")
    + "</div>\n</div>\n";
},"useData":true})

});
